import { Globe2, Building2, Clock, Layers, MapPinned } from "lucide-react";
import FadeUp from "@/components/landing/FadeUp";
import { MAP_PINS, NETWORK } from "./content";
import { SectionHeading } from "./Primitives";
import WorldMap from "./WorldMap";

const icons = [MapPinned, Globe2, Building2, Clock, Layers];

export const GlobalNetwork = () => (
    <section id="global-network" data-testid="global-network-section" className="section-pad bg-white">
        <div className="container-page">
            <SectionHeading
                eyebrow="Global talent network"
                title={NETWORK.heading}
                testId="global-network-heading"
            />
            <div className="mt-12 md:mt-16 grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-5">
                    <FadeUp>
                        <ul className="space-y-3">
                            {NETWORK.questions.map((q) => (
                                <li key={q} className="text-lg md:text-xl font-semibold text-hire-ink leading-snug">
                                    {q}
                                </li>
                            ))}
                        </ul>
                    </FadeUp>
                    <FadeUp delay={0.08}>
                        <p className="mt-7 text-base text-hire-muted leading-relaxed">{NETWORK.body1}</p>
                        <p className="mt-4 text-base text-hire-muted leading-relaxed">{NETWORK.body2}</p>
                    </FadeUp>
                    <FadeUp delay={0.12}>
                        <ul data-testid="network-highlights" className="mt-8 flex flex-wrap gap-2.5">
                            {NETWORK.highlights.map((h, i) => {
                                const Icon = icons[i];
                                return (
                                    <li
                                        key={h}
                                        className="inline-flex items-center gap-2 rounded-full border border-hire-line bg-white px-3.5 py-2 text-[13px] font-medium text-hire-ink"
                                    >
                                        <Icon className="h-3.5 w-3.5 text-brand-blue" />
                                        {h}
                                    </li>
                                );
                            })}
                        </ul>
                    </FadeUp>
                </div>
                <FadeUp delay={0.1} className="lg:col-span-7">
                    <div className="rounded-3xl border border-hire-line bg-hire-bg p-5 sm:p-8">
                        <WorldMap pins={MAP_PINS} className="w-full h-auto" dotColor="#C9CFDB" />
                        <p className="mt-4 text-[11.5px] text-hire-muted">{NETWORK.mapNote}</p>
                    </div>
                </FadeUp>
            </div>
        </div>
    </section>
);

export default GlobalNetwork;
